import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import Button from '@mui/material/Button';

import { useLocalStorage } from "../components/useLocalStorage";
import { useNavigate, Outlet, Link } from "react-router-dom";

const AppBoardScreen = () => {
    const [ElectronicReceiptShippingUpdatesHidden, setElectronicReceiptShippingUpdatesHidden] = useLocalStorage("ElectronicReceiptShippingUpdatesHidden", "");
    const navigate = useNavigate();
    return (
        <Box id="AppBoardScreen1" className="AppBoardScreen AppBoardScreen1" sx={{ width: 800, m: "auto",  backgroundColor: '#fefefe', p: 6.25 }}>
            <input type="hidden" value={ElectronicReceiptShippingUpdatesHidden} />
            <Grid container spacing={2} sx={{ textAlign: "center" }}>
                <Grid item xs={12} sx={{ textAlign: "left" }}>
                    <Link to="/dmv/cambio/TextWithRatesRenewal">
                        <Button variant="outlined" size="large">Regresar</Button>
                    </Link>
                </Grid>
                <Grid item xs={12}>
                    <h2 className="subHeading">﻿¿Te gustaría recibir tu comprobante electrónico, actualizaciones de envío y recordatorios de pago por correo electrónico?</h2>
                </Grid>
                <Grid item xs={12}>      
                    <Button onClick={ () => { setElectronicReceiptShippingUpdatesHidden("Yes"); setTimeout(() => { navigate("/dmv/cambio/WhatYourEmail")}, 100) }} variant="contained" color="success" size="large" sx={{ width: "50%" }}>Si</Button>
                </Grid>
                <Grid item xs={12}>
                    <Button onClick={ () => { setElectronicReceiptShippingUpdatesHidden("No"); setTimeout(() => { navigate("/dmv/cambio/TextWithRatesRenewal")}, 100) }} variant="contained" color="error" size="large" sx={{ width: "50%" }}>No</Button>                  
                </Grid>

                <Outlet/>

            </Grid>
        </Box>
    );
};

export default AppBoardScreen;